(function() {
  var el = document.querySelector('.fs-power-slider');
  if (!el) return;

  var track     = el.querySelector('[data-track]');
  var prevBtn   = el.querySelector('[data-prev]');
  var nextBtn   = el.querySelector('[data-next]');
  var dotsWrap  = el.querySelector('[data-dots]');
  var playPause = el.querySelector('[data-play-pause]');

  // Remove slides that are outside their scheduled window — either not
  // started yet (show-from) or already expired (hide-after). Both checks
  // compare against the visitor's real current time, so this works
  // automatically on every page view with no republish needed either way.
  el.querySelectorAll('.fs-power-slider__slide').forEach(function(slide, i) {
    var showFrom  = slide.dataset.showFrom;
    var hideAfter = slide.dataset.hideAfter;
    var now = Date.now();
    var notStartedYet = false;
    var expired = false;

    if (showFrom) {
      var start = new Date(showFrom);
      if (!isNaN(start) && now < start.getTime()) notStartedYet = true;
    }
    if (hideAfter) {
      var expiry = new Date(hideAfter);
      if (!isNaN(expiry) && now > expiry.getTime()) expired = true;
    }

    if (notStartedYet || expired) {
      if (dotsWrap) {
        var dot = dotsWrap.querySelector('[data-index="' + i + '"]');
        if (dot) dot.remove();
      }
      slide.remove();
    }
  });

  // Re-index remaining dots after any removals
  if (dotsWrap) {
    dotsWrap.querySelectorAll('.fs-power-slider__dot').forEach(function(dot, i) {
      dot.dataset.index = String(i);
    });
  }

  var slides = el.querySelectorAll('.fs-power-slider__slide');
  var total  = slides.length;

  if (total === 0) { el.style.display = 'none'; return; }

  var current       = 0;
  var autoplayTimer = null;
  var stagnantTmr   = null;
  var userPaused    = false;
  var isDragging    = false;
  var dragStartX    = 0;
  var dragDeltaX    = 0;
  var loop          = el.dataset.loop === 'true';
  var autoplay      = el.dataset.autoplay === 'true';
  var speed         = parseInt(el.dataset.autoplaySpeed) || 5000;
  var initialDelay  = parseInt(el.dataset.autoplayInitialDelay) || speed;

  // ── Navigation ────────────────────────────────────────────────────────────

  function go(index) {
    if (loop) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
    } else {
      index = Math.max(0, Math.min(index, total - 1));
    }
    current = index;
    update();
  }

  function update() {
    slides.forEach(function(slide, i) {
      var active = i === current;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
      var focusable = slide.querySelector('.fs-power-slider__slide-link, .fs-power-slider__btn');
      if (focusable) focusable.setAttribute('tabindex', active ? '0' : '-1');
    });

    var theme = slides[current] && slides[current].dataset.controlsTheme;
    el.classList.toggle('controls-light', theme === 'light');

    if (prevBtn) prevBtn.disabled = !loop && current === 0;
    if (nextBtn) nextBtn.disabled = !loop && current === total - 1;

    if (dotsWrap) {
      dotsWrap.querySelectorAll('.fs-power-slider__dot').forEach(function(dot, i) {
        var active = i === current;
        dot.setAttribute('aria-selected', String(active));
        dot.setAttribute('tabindex', active ? '0' : '-1');
      });
    }
  }

  // ── Autoplay ──────────────────────────────────────────────────────────────

  function startAutoplay(isInitial) {
    stopAutoplay();
    var delay = isInitial ? initialDelay : speed;
    autoplayTimer = setTimeout(function tick() {
      go(current >= total - 1 ? 0 : current + 1);
      autoplayTimer = setTimeout(tick, speed);
    }, delay);
  }

  function stopAutoplay() {
    if (autoplayTimer) { clearTimeout(autoplayTimer); autoplayTimer = null; }
  }

  // ── Controls visibility ───────────────────────────────────────────────────

  function showControls() {
    el.classList.add('controls-visible');
  }

  function hideControls() {
    el.classList.remove('controls-visible');
    clearTimeout(stagnantTmr);
  }

  function onMouseActivity() {
    showControls();
    if (!userPaused) stopAutoplay();
    clearTimeout(stagnantTmr);
    stagnantTmr = setTimeout(function() {
      hideControls();
      if (!userPaused && autoplay) startAutoplay();
    }, 2500);
  }

  // ── Play / pause ──────────────────────────────────────────────────────────

  function togglePlayPause() {
    userPaused = !userPaused;
    if (userPaused) {
      stopAutoplay();
      el.classList.add('is-paused');
      if (playPause) {
        playPause.setAttribute('aria-label', 'Play slideshow');
        playPause.setAttribute('aria-pressed', 'true');
      }
    } else {
      startAutoplay();
      el.classList.remove('is-paused');
      if (playPause) {
        playPause.setAttribute('aria-label', 'Pause slideshow');
        playPause.setAttribute('aria-pressed', 'false');
      }
    }
  }

  // ── Event binding ─────────────────────────────────────────────────────────

  if (prevBtn) prevBtn.addEventListener('click', function() { go(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function() { go(current + 1); });

  if (dotsWrap) {
    dotsWrap.querySelectorAll('.fs-power-slider__dot').forEach(function(dot) {
      dot.addEventListener('click', function() { go(parseInt(dot.dataset.index)); });
    });
  }

  if (playPause) playPause.addEventListener('click', togglePlayPause);

  // Swipe / drag
  track.addEventListener('pointerdown', function(e) {
    isDragging = true;
    dragStartX = e.clientX;
    dragDeltaX = 0;
    stopAutoplay();
  });
  track.addEventListener('pointermove', function(e) {
    if (!isDragging) return;
    dragDeltaX = e.clientX - dragStartX;
  });
  track.addEventListener('pointerup', function() {
    if (!isDragging) return;
    isDragging = false;
    if (dragDeltaX < -50) go(current + 1);
    else if (dragDeltaX > 50) go(current - 1);
    dragDeltaX = 0;
    if (!userPaused && autoplay) startAutoplay();
  });
  track.addEventListener('pointercancel', function() { isDragging = false; });

  // Keyboard
  el.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowLeft') go(current - 1);
    if (e.key === 'ArrowRight') go(current + 1);
  });

  // Mouse activity → show controls, pause autoplay, start stagnant timer (throttled)
  var mouseThr = null;
  el.addEventListener('mousemove', function() {
    if (mouseThr) return;
    mouseThr = setTimeout(function() { mouseThr = null; }, 200);
    onMouseActivity();
  });
  el.addEventListener('mouseleave', function() {
    hideControls();
    if (!userPaused && autoplay) startAutoplay();
  });

  // Focus
  el.addEventListener('focusin', function() { showControls(); stopAutoplay(); });
  el.addEventListener('focusout', function(e) {
    if (!el.contains(e.relatedTarget)) {
      hideControls();
      if (!userPaused && autoplay) startAutoplay();
    }
  });

  // ── Init ──────────────────────────────────────────────────────────────────

  update();
  // Autoplay's first countdown only starts once the page has actually
  // finished loading — never on a blind calendar timer. That way the very
  // first slide transition can never fire while the browser's LCP
  // observation window is still open, regardless of how much other page
  // weight (scripts, third-party tags) delays full load in the future.
  if (autoplay) {
    if (document.readyState === 'complete') {
      startAutoplay(true);
    } else {
      window.addEventListener('load', function() { startAutoplay(true); }, { once: true });
    }
  }
})();
